import { defineStore } from 'pinia';
import { iStorePresets, tStorePresetsLib } from '@/Interfaces/presets';
import { tCaseModel } from '@/Interfaces/caseComponentsLib';

export const useStorePresets = defineStore('storePresets', {
    state: (): iStorePresets => ({
        presets: [],
    }),
    getters: {
        getPresetById: (state) => {
            return (id: string) => {
                return state.presets.find(item => item.id === id);
            };
        },
        getPresetsByCaseModel(state) {
            return (model: tCaseModel) => {
                return state.presets.filter(item => item.caseModel === model);
            };
        },
    },
    actions: {
        loadPresetsCatalog(data: tStorePresetsLib) {
            this.presets = [ ...data ];
        },
    },
});
